/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { ControlTable } from "../../components/Table";
import { each, get, isEmpty } from "lodash";
import { getParams } from "../../utils/params";
import useForm from "../../hooks/useForm";
import { deleteEmployeeFamily, getEmployeeFamilyList } from "../../apis/employee/employee-family";
import { viewLoading } from "../../utils/loading";
import { toast } from "../../utils/toast";
import systemAlert from "../../utils/systemAlert";
import Button from "../Button";
import EmployeeFamilyDetailPopup from "./EmployeeFamilyDetailPopup";

const EmployeeFamilyList = (props) => {
  const { employee } = props
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState({});

  const [fields] = useState([
    { title: "가족이름", key: "name" },
    { title: "가족관계", key: "relationship" },
    { title: "생년월일", key: "birthDate", type: 'date' },
    { title: "연락처", key: "phone" },
  ]);

  const {
    form,
    setSubmit,
    setForm,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      order: [
        {
          idx: "desc"
        },
      ],
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    setSubmit(submit)
    if (employee) {
      const _form = {
        ...form,
        search: {
          employeeIdx: employee.idx
        }
      }
      submit(_form);
      setForm(_form)
    }
  }, [employee]);

  const buttons = [
    {
      label: "삭제",
      color: "gray-line",
      action: async () => {
        systemAlert(`${selectedList.length}명의 가족정보를 삭제하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '삭제',
              onClick: () => {
                const promiseList = []
                viewLoading(true)
                each(selectedList, item => {
                  promiseList.push(deleteEmployeeFamily(item.familyIdx, item.employeeIdx))
                })
                Promise.all(promiseList)
                  .then(() => {
                    toast.info('가족 정보가 삭제되었습니다.')
                    filterSubmit()
                    setSelectedList([])
                  })
                  .finally(() => {
                    viewLoading(false)
                  })
              }
            }
          ]
        })


      },
      isDisabled: isEmpty(selectedList),
    },
  ];

  const submit = (param) => {
    setIsLoading(true)
    getEmployeeFamilyList(getParams(param))
      .then((res) => {
        setTotal(res.data.total);
        setList(get(res, "data.families"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false)
        setSelectedList([]);
      });

  };

  const handleRowClick = (data) => {
    setDetailData(data)
    setDetailOpen(true)
  }

  useEffect(() => {
    if (!detailOpen) setDetailData({})
  }, [detailOpen])

  return (
    <>
      <div className="clear mb-16">
        <Button
          className="float-right"
          label="가족정보 추가"
          action={() => {
            setDetailOpen(true)
          }}
        />
      </div>
      <ControlTable
        title={`${employee.name}님의 가족정보 목록`}
        fields={fields}
        list={list}
        buttons={buttons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        submit={handleSubmit}
        onSelect={handleRowClick}
      />
      <EmployeeFamilyDetailPopup
        employee={employee}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={filterSubmit}
        data={detailData}
      />
    </>
  );
};

export default EmployeeFamilyList;
